import React, { useEffect, useRef, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { FaBars, FaTimes } from 'react-icons/fa';
import { setIsLoggedIn, setIsSidebarCollapsed } from './reduxToolkit/redux';
import { clearBillingSession } from './billing/billingClient';
import NavbarMO from './NavbarMO';
import './Navbar.scss';

function Navbar({ onOpenBrochureModal }) {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const isLoggedIn = useSelector((state) => state.reduxStore.isLoggedIn);
  const isLoginPage = useSelector((state) => state.reduxStore.isLoginPage);
  const version = useSelector((state) => state.reduxStore.version);
  const acaName = useSelector((state) => state.reduxStore.acaName);
  const isSidebarCollapsed = useSelector((state) => state.reduxStore.isSidebarCollapsed);
  const [isOpen, setIsOpen] = useState(false);
  const [isTablet, setIsTablet] = useState(window.innerWidth > 768 && window.innerWidth <= 1200);
  const menuToggleRef = useRef(null);
  const isAndroid = Boolean(version && version.toLowerCase().includes('android'));
  const homeIsActive = ['/', '/homeApp', '/main'].includes(location.pathname);

  useEffect(() => {
    function handleResize() {
      setIsTablet(window.innerWidth > 768 && window.innerWidth <= 1200);
      if (window.innerWidth > 1200) setIsOpen(false);
    }
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => { setIsOpen(false); }, [location.pathname]);

  useEffect(() => {
    if (!isOpen) return undefined;
    function handleKeyDown(event) {
      if (event.key === 'Escape') {
        setIsOpen(false);
        menuToggleRef.current?.focus();
      }
    }
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [isOpen]);

  function onToggleLogin() {
    if (isLoggedIn) {
      if (!window.confirm('로그아웃하시겠습니까?')) return;
      localStorage.removeItem('guardianLoginSession');
      clearBillingSession();
      dispatch(setIsLoggedIn(false));
      navigate('/');
    } else {
      navigate('/login');
    }
    setIsOpen(false);
  }

  function openBrochure() {
    setIsOpen(false);
    if (onOpenBrochureModal) {
      onOpenBrochureModal();
    } else {
      window.location.assign('/bruchure.pdf');
    }
  }

  function onCloseApp() {
    if (typeof window.myJSInterface?.CloseAppReact === 'function') {
      window.myJSInterface.CloseAppReact('');
    }
  }

  return <>
    <nav className="navbar lms-navbar" aria-label="주 메뉴">
      {isTablet && (
        <button
          className="navbar-tablet-toggle"
          type="button"
          aria-label={isSidebarCollapsed ? '학습 메뉴 펼치기' : '학습 메뉴 접기'}
          aria-expanded={!isSidebarCollapsed}
          title="학습 메뉴"
          onClick={() => dispatch(setIsSidebarCollapsed(!isSidebarCollapsed))}
        ><FaBars aria-hidden="true" /></button>
      )}
      <Link className="navbar-logo" to="/homeApp" title={acaName || 'AI K-EDU'}>
        {acaName || 'AI K-EDU'}
      </Link>

      <div className="navbar-menu">
        <Link className="btn-menu" to="/" aria-current={homeIsActive ? 'page' : undefined}>HOME</Link>
        <Link className="btn-menu" to="/board" aria-current={location.pathname === '/board' ? 'page' : undefined}>공지사항</Link>
        <button className="btn-menu" type="button" onClick={openBrochure}>브로셔</button>
        <Link className="btn-menu" to="/storeBook" aria-current={location.pathname === '/storeBook' ? 'page' : undefined}>교재(문제)구매</Link>
        {isLoggedIn && <Link className="btn-menu" to="/directMessageApp" aria-current={location.pathname === '/directMessageApp' ? 'page' : undefined}>문자전송</Link>}
      </div>

      <div className="box_navar-login">
        <button className="navbar-login" type="button" onClick={onToggleLogin}>{isLoggedIn ? '로그아웃' : '로그인'}</button>
        {isLoginPage && isAndroid && <button className="closeApp" type="button" onClick={onCloseApp}>종료</button>}
      </div>
    </nav>

    <div className="navbar-mo lms-navbar-mo">
      <NavbarMO
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        isLoggedIn={isLoggedIn}
        onToggleLogin={onToggleLogin}
        onOpenBrochureModal={openBrochure}
      />
      <button
        ref={menuToggleRef}
        className="navbar-toggler"
        type="button"
        aria-label={isOpen ? '전체 메뉴 닫기' : '전체 메뉴 열기'}
        aria-expanded={isOpen}
        aria-controls={isOpen ? 'lms-mobile-menu' : undefined}
        onClick={() => setIsOpen((current) => !current)}
      >{isOpen ? <FaTimes aria-hidden="true" /> : <FaBars aria-hidden="true" />}</button>
    </div>
  </>;
}

export default Navbar;
